<mat-form-field
  appearance="outline"
  class="sia-inputs-full sia-input"
  floatLabel="always"
  [class]="inputClass()"
  [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
>
  <mat-label
    >{{ label() | siaTranslate }}
    @if (info()) {
      <span
        [siaTooltip]="info() ?? ''"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon()"
      >
      </span>
    }
  </mat-label>
  <textarea
    #siaTextarea
    (input)="autoAdjustHeight() ? requestAutoResize() : null"
    [siaTooltip]="fieldErrors()"
    [disable]="!visibleTooltip()"
    matInput
    rows="1"
    [id]="id() ?? ''"
    [(ngModel)]="value"
    [disabled]="isDisabled() || isTyping() || promptLoading()"
    [style]="
      autoAdjustHeight()
        ? 'min-height:' + normalizedMinHeight() + '; overflow-y:hidden;'
        : isFixedHeight()
          ? 'height:' + normalizedMinHeight() + '; resize:vertical;'
          : 'min-height:' +
            normalizedMinHeight() +
            '; max-height:' +
            normalizedMaxHeight() +
            '; resize:vertical;'
    "
    [class.typing-animation]="isTyping()"
  ></textarea>
  @if (showBottomMargin()) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage()"
      [statusMessages]="statusMessages()"
    ></mat-hint>
  }
</mat-form-field>
@if (environmentService.aiEnabled && !forceDisableAI()) {
  <sia-ai-text-button
    [(text)]="value"
    (promptLoading)="onPromptLoading($event)"
    [category]="'crud-text-box'"
    [style]="showBottomMargin() ? 'margin-bottom: 16px' : ''"
    [disabled]="isDisabled()"
  ></sia-ai-text-button>
}
